import React from "react";
import { useHistory } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

export default function Auth0ProviderWithHistory(props: any) {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN ?? "";
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID ?? "";

  const history = useHistory();

  // After login, take users back where they requested.
  const onRedirectCallback = (appState: any) => {
    const returnTo = appState?.returnTo || window.location.pathname;
    const appStateDraftTokens = (appState?.draftTokens as string[] | undefined) ?? [];
    const localStorageTokens = JSON.parse(localStorage.getItem('agcredit_draft_tokens') ?? '[]') as string[];
    const allTokens = [...[...appStateDraftTokens, ...localStorageTokens]];
    const path = allTokens.length > 0
      ? `${returnTo}?claimTokens=${encodeURIComponent(JSON.stringify(allTokens))}`
      : returnTo;
    history.push(path);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin + "/callback"}
      onRedirectCallback={onRedirectCallback}
    >
      {props.children}
    </Auth0Provider>
  );
};

//export default Auth0ProviderWithHistory;
